import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AgilityRiskService } from '../../../../../providers/agility-risk.service';
import { RiskFactor } from '../../../../../models/risk-factor';

@Component({
  selector: 'lib-risk-assessment-survey-definitions-modal',
  templateUrl: './risk-assessment-survey-definitions-modal.component.html',
  styleUrls: ['./risk-assessment-survey-definitions-modal.component.scss']
})
export class RiskAssessmentSurveyDefinitionsModalComponent {
  public riskFactors: Array<RiskFactor> = [];

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public agilityRiskService: AgilityRiskService,
              public dynamicDialogConfig: DynamicDialogConfig) {
    this.riskFactors = this.dynamicDialogConfig?.data?.riskFactors;
  }

  closeModal(): void {
    this.dynamicDialogRef.close();
  }
}
